/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const shortManageRouter = {
  path: '/short-manage',
  component: Layout,
  redirect: '/short-manage/sharing',
  name: 'ShortManage',
  meta: {
    title: 'shortManage',
    icon: 'user'
  },
  children: [
    // 剧付费管理
    {
      path: 'episode-pay',
      component: () => import('@/views/short-manage/episode-pay'),
      name: 'EpisodePay',
      meta: { title: 'episodePay', noCache: false }
    },
    // 剧付费明细
    {
      path: 'episode-buy-itemized',
      component: () => import('@/views/short-manage/episode-buy-itemized'),
      name: 'EpisodeBuyItemized',
      meta: { title: 'episodeBuyItemized', noCache: false }
    },
    // 分成管理
    {
      path: 'sharing',
      component: () => import('@/views/short-manage/sharing/index'),
      name: 'Sharing',
      meta: { title: 'sharing', noCache: false }
    },
    // 提现管理
    {
      path: 'withdraw',
      component: () => import('@/views/short-manage/withdraw/index'),
      name: 'Withdraw',
      meta: { title: 'withdrawInShort', noCache: false }
    }
  ]
}

export default shortManageRouter
